export default "__VITE_ASSET__CyfbxK$H__"